module.exports = __webpack_public_path__ + "img/2166.5df2721d.gif";